var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-panel__button-item" }, [
    _c(
      "button",
      {
        staticClass: "button button_theme_color ym-param",
        attrs: { "data-url": _vm.link.href },
        on: {
          click: function($event) {
            return _vm.goToParam(_vm.link.href)
          }
        }
      },
      [
        _vm._v("\n        Смотреть \n        "),
        _c("span", { staticClass: "search-panel__filter-count" }, [
          _vm._v("\n            " + _vm._s(_vm.link.text) + "\n        ")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }